import { render, staticRenderFns } from "./SharedSettings.vue?vue&type=template&id=02a6d61e&scoped=true&"
import script from "./SharedSettings.vue?vue&type=script&lang=js&"
export * from "./SharedSettings.vue?vue&type=script&lang=js&"
import style0 from "./SharedSettings.vue?vue&type=style&index=0&id=02a6d61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a6d61e",
  null
  
)

component.options.__file = "SharedSettings.vue"
export default component.exports